<template>
    <div class="app" style="height: 100%;">

        <template>
            <div class="choice-list">
                <van-cell :title="item.childBillingAccountName" is-link  @click="choiceProject(item)" v-for="item in subSubjectList" :key="item.id.value"/>
            </div>
        </template>
    </div>
</template>
<script>

import { Cell } from "vant";
import {mapState} from "pinia";
import useformStore from "@/store/sporadicChargeform";
import chargeProjectStore from "@/store/chargeProject";

export default {
    name: "choiceSubSubject",
    components: {
         "van-cell": Cell,
    },
    props: {

    },
    data() {
        return {
            subSubjectList:[],
        };
    },
    created() {
      this.getSubSubProjectList();
    },
    computed: {
      ...mapState(useformStore, ['form']),
      ...mapState(chargeProjectStore, ['chargeProject']),
    },
    methods: {
      getSubSubProjectList() {
        const chargeProjectList = chargeProjectStore();
        this.subSubjectList = chargeProjectList.getStrSubProjectList;
      },
        choiceProject(item){
            console.log(item);
            const formStore = useformStore();
            formStore.setForm(
                {
                strProject: formStore?.form?.strProject,
                strSubject: formStore?.form?.strSubject,
                strSubSubject: item,
                strPrice: formStore?.form?.strPrice,
                strRemarks: formStore?.form?.strRemarks,
                paymentUpperLimit : formStore?.form?.paymentUpperLimit,
                }

            )
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped>
.choice-list{
    width: 353px;
    border: 1px solid #E7E5E7;
    border-radius: 10px;
    margin: 10px;
}
.title {
    padding: 10px;
}

.choice-project-button {
    width: 70px;
    height: 36px;
    float: right;
    margin-top: -40px;
    margin-right: 40px;
}

.choice-project-search>>>.van-icon-search:before {
    content: '';
}

.choice-project-search {
    width: 275px;
    height: 44px;
    /* float: left; */
}
.choice-project-search >>> .van-search__content {
    border: 1px solid #E7E5E7;
    background-color: white;
}
</style>
